import { tKey, type I18nKey } from "@/core/i18n";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

type StreamStatusBadgeVariant = "live" | "recording" | "replay" | "offline";

interface StreamStatusBadgeProps {
  variant: StreamStatusBadgeVariant;
  className?: string;
}

const BASE = "px-2.5 py-1.5 rounded-md text-xs font-bold uppercase";

const VARIANTS: Record<StreamStatusBadgeVariant, string> = {
  live: "bg-red-50 text-red-700",
  recording: "bg-red-600 text-white flex items-center gap-1.5",
  replay: "bg-blue-50 text-blue-700",
  offline: "bg-red-50 text-red-700",
};

const LABELS = {
  live: tKey("camera:stream.status.live"),
  recording: tKey("camera:stream.status.recording"),
  replay: tKey("camera:stream.status.replay"),
  offline: tKey("camera:stream.status.offline"),
} satisfies Record<StreamStatusBadgeVariant, I18nKey<"camera">>;

export const StreamStatusBadge = ({ variant, className }: StreamStatusBadgeProps) => {
  const { t } = useTranslation(["camera"]);
  return (
    <span className={cn(BASE, VARIANTS[variant], className)}>
      {variant === "recording" && (
        <span className="h-2 w-2 animate-pulse rounded-full bg-white" />
      )}
      {t(LABELS[variant])}
    </span>
  );
};
